define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"Quality/TestRunActionMixin"
], function(declare,EditController,TestRunActionMixin) {

	return declare([EditController, TestRunActionMixin], {
		/**
		 * Hide unnecessary fields from edit form
		 */
		onCreatePopupDefView: function(defView) {
			this._hideFields(defView, this.m_cache);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			this._disableColorOrSample(view);
			this.inherited(arguments);
		}
	});
});